import React from "react"
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io"
import { useSwipeable } from "react-swipeable"
import LoadingSpinner from "../../atoms/LoadingSpinner"
import PimImage from "../../atoms/PimImage"
import * as styles from "./ProductPageImages.module.scss"

export type ProductPageImage = {
  src: string
  thumbnail: string
  title?: string
  alt?: string
  fit?: "cover" | "contain"
}
export type ProductPageImagesProps = { images: ProductPageImage[] }

const ProductImageFull = (props: {
  src: string
  alt?: string
  loading?: boolean
  onLoad: any
  fit: "cover" | "contain"
}) => {
  return (
    <div className={styles.full}>
      <PimImage
        src={props.src}
        alt={props.alt}
        onLoad={props.onLoad}
        style={{ objectFit: props.fit, ...(props.loading ? { opacity: 0.5 } : {}) }}
        itemProp="image"
        // height={600}
        // width={600}
      />
      <LoadingSpinner overlay loading={props.loading} />
    </div>
  )
}

const ThumbImage = (props: { src: string; alt?: string; onClick: any; active?: boolean }) => {
  return (
    <PimImage
      className={`${styles.thumb} ${props.active ? styles.active : ""}`}
      src={props.src}
      alt={props.alt}
      onClick={props.onClick}
    />
  )
}

const ProductPageImages = (props: ProductPageImagesProps) => {
  // console.debug("Rendering ProductPageImages", props)

  const [currentImage, setCurrentImage] = React.useState(0)
  const [loading, setLoading] = React.useState(false)

  const load = (i: number) => {
    if (i !== currentImage) {
      setLoading(true)
      setCurrentImage(i)
    }
  }
  const loaded = (e: Event) => {
    setLoading(false)
  }

  const next = () => {
    if (currentImage < props.images.length - 1) setCurrentImage(currentImage + 1)
  }
  const prev = () => {
    if (currentImage > 0) setCurrentImage(currentImage - 1)
  }

  const swipeHandlers = useSwipeable({
    onSwipedLeft: next,
    onSwipedRight: prev,
    // preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  })

  if (!props.images || !props.images.length) return null

  return (
    <div className={styles.container} {...swipeHandlers}>
      <ProductImageFull
        src={props.images[currentImage].src}
        alt={props.images[currentImage].alt}
        onLoad={loaded}
        loading={loading}
        fit={props.images[currentImage].fit || "cover"}
      />
      {props.images.length > 1 && (
        <>
          <ul className={styles.thumbs}>
            {props.images.map((img, i) => {
              return (
                <li key={`thumb-${i}`}>
                  <ThumbImage src={img.thumbnail} alt={img.alt} onClick={() => load(i)} active={currentImage == i} />
                </li>
              )
            })}
          </ul>

          <div className={styles.controls}>
            <button onClick={prev} title="Previous">
              <IoIosArrowBack />
            </button>
            <button onClick={next} title="Next">
              <IoIosArrowForward />
            </button>
          </div>
        </>
      )}
    </div>
  )
}

export default ProductPageImages
